// FontAwesome Free - Brands (fab)
import {
  faBloggerB,
  faBuffer,
  faDiaspora,
  faFacebookF,
  faFacebookMessenger,
  faFlipboard,
  faGetPocket,
  faInstagram,
  faLine,
  faLinkedinIn,
  faPinterestP,
  faQq,
  faRedditAlien,
  faTelegram,
  faTiktok,
  faTumblr,
  faTwitch,
  faViber,
  faVk,
  faWeibo,
  faWhatsapp,
  faXTwitter,
  faYoutube,
  IconDefinition,
} from '@fortawesome/free-brands-svg-icons';

/**
 * Single source of truth pairing each supported icon name (as used via JSON)
 * with its FontAwesome definition. The list, type, and definitions below are
 * all derived from this map, so a name can never drift out of sync with its definition.
 */
export const FabIconMap = {
  'fab:blogger-b': faBloggerB,
  'fab:buffer': faBuffer,
  'fab:diaspora': faDiaspora,
  'fab:facebook-f': faFacebookF,
  'fab:facebook-messenger': faFacebookMessenger,
  'fab:flipboard': faFlipboard,
  'fab:get-pocket': faGetPocket,
  'fab:instagram': faInstagram,
  'fab:line': faLine,
  'fab:linkedin-in': faLinkedinIn,
  'fab:pinterest-p': faPinterestP,
  'fab:qq': faQq,
  'fab:reddit-alien': faRedditAlien,
  'fab:telegram': faTelegram,
  'fab:tiktok': faTiktok,
  'fab:tumblr': faTumblr,
  'fab:twitch': faTwitch,
  'fab:viber': faViber,
  'fab:vk': faVk,
  'fab:weibo': faWeibo,
  'fab:whatsapp': faWhatsapp,
  'fab:x-twitter': faXTwitter,
  'fab:youtube': faYoutube,
} satisfies Record<`fab:${string}`, IconDefinition>;

/**
 * Generated type from the supported icon names.
 */
export type FabIcons = keyof typeof FabIconMap;

/**
 * The Supported Icon Names used via JSON.
 */
export const FabList = Object.keys(FabIconMap) as readonly FabIcons[];

/**
 * All FontAwesome Brand Icons available for the system
 * to use with Material Design are defined here.
 */
export const FabIconDefinitions: IconDefinition[] = Object.values(FabIconMap);
